import { render, staticRenderFns } from "./jy_Deodorizer2.vue?vue&type=template&id=21c479a5"
import script from "./jy_Deodorizer2.vue?vue&type=script&lang=js"
export * from "./jy_Deodorizer2.vue?vue&type=script&lang=js"
import style0 from "./jy_Deodorizer2.vue?vue&type=style&index=0&id=21c479a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports